export default "/_next/static/chunks/fonts/IBM Plex Sans Thin-b60640baf98fd00fe1795d8ad5fbf89f.ttf";